import {
	createContext,
	PropsWithChildren,
	useCallback,
	useContext,
	useMemo,
	useState,
} from 'react'
import Confetti from 'react-confetti'

interface TopicCompletionConfettiContextValue {
	showTopicCompletionConfetti: () => void
}

const TopicCompletionConfettiContext =
	createContext<TopicCompletionConfettiContextValue | null>(null)

export const TopicCompletionConfettiProvider = ({
	children,
}: PropsWithChildren) => {
	const [isConfettiActive, setIsConfettiActive] = useState(false)

	const showTopicCompletionConfetti = useCallback(() => {
		setIsConfettiActive(true)
	}, [])
	const contextValue = useMemo(
		() => ({ showTopicCompletionConfetti }),
		[showTopicCompletionConfetti],
	)

	return (
		<TopicCompletionConfettiContext.Provider value={contextValue}>
			{isConfettiActive ? (
				<Confetti
					recycle={false}
					numberOfPieces={250}
					gravity={0.4}
					onConfettiComplete={() => setIsConfettiActive(false)}
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						pointerEvents: 'none',
						zIndex: 2000,
					}}
				/>
			) : null}
			{children}
		</TopicCompletionConfettiContext.Provider>
	)
}

export const useTopicCompletionConfetti = () => {
	const context = useContext(TopicCompletionConfettiContext)

	if (!context) {
		throw new Error(
			'useTopicCompletionConfetti must be used within TopicCompletionConfettiProvider',
		)
	}

	return context
}
